"use client";
import React, { Suspense, useState } from "react";
import { AuthLayout } from "@/components/auth/AuthLayout";
import { SignInForm } from "@/components/auth/SignInForm";
import { SignUpWizard } from "@/components/auth/SignUpWizard";

export default function SignInPage() {
    const [mode, setMode] = useState<"signin" | "signup">("signin");

    return (
        <AuthLayout
            subtitle={mode === "signin"
                ? "© 2026 Savira. All rights reserved."
                : "Join the elite organizations transforming their strategy through AI."
            }
        >
            <Suspense fallback={<p className="text-sm font-semibold text-ink-3">Loading…</p>}>
                {mode === "signin" ? (
                    <SignInForm onToggleSignUp={() => setMode("signup")} />
                ) : (
                    <SignUpWizard />
                )}
            </Suspense>
        </AuthLayout>
    );
}
